/**
 * @type {{[key in scResourceType]:{bg,fg}}}
 */
export var colorsByType = {
  'public-function': {
    bg: '#FF000F',
    fg: 'black'
  },
  'public-function-view': {
    bg: '#ff9190',
    fg: 'black'
  },
  'event': {
    bg: '#FFCE4F',
    fg: 'black'
  },
  'literal': {
    bg: 'transparent',
    fg: 'pink'
  },
  'modifier': {
    bg: '#E28FFF',
    fg: 'black'
  },
  'storage': {
    bg: '#3D50FF',
    fg: 'white'
  },
  'storage': {
    bg: '#3D50FF',
    fg: 'white'
  },
  'storage-constant': {
    bg: '#c5c8e2',
    fg: '#5e5e5e'
  },
  "block-tx-data": {
    bg: '#A3A3A3',
    fg: 'black'
  },
  'readonly-public-function': {
    bg: '#FF9090',
    fg: 'black'
  },
  'other': {
    bg: '#B3FF8F',
    fg: 'black'
  },
}
export var leftSizeMinWidth = 600
export var leftDefaultWidth = window.innerWidth * 0.4

export var resourceTabList=[
  {
    name:"Modifiers",
    navigateOnClickOnType:['modifier']
  },
  {
    name: "Storage",
    navigateOnClickOnType:['read-storage','write-storage','storage']
  },
  {
    name: "Functions",
    navigateOnClickOnType:['public-function','public-function-view']
  },
  {
    name: "Events",
    navigateOnClickOnType:['event']
  },
  {
    name: "Block & TX Data",
    navigateOnClickOnType:['block-tx-data']
  },
  {
    name: "Other",
    navigateOnClickOnType:['other']
  },
]


/**
 * @type {{
 * type:scResourceType
 * tabId
 * bg
 * fg
 * }[]}
 */
export var typesInTabs = [
  {
    type: "modifier",
    tabId: 'Modifiers',
    bg: '#E28FFF',
    fg: 'black'
  },
  {
    type: 'public-function',
    tabId:'Functions',
    bg: '#FF000F',
    fg: 'black'
  },
  {
    type: 'event',
    tabId:'Events',
    bg: '#FFCE4F',
    fg: 'black'
  },
  {
    type: 'event-call',
    tabId:'Events',
    bg: '#FFCE4F',
    fg: 'black'
  },
  {
    type: 'literal',
    bg: 'transparent',
    fg: 'pink'
  },
  {
    type: 'storage',
    tabId:'Storage',
    bg: '#3D50FF',
    fg: 'white'
  },
  {
    type: 'read-storage',
    tabId:'Storage',
    bg: '#3D50FF',
    fg: 'white'
  },
  {
    type: 'write-storage',
    tabId:'Storage',
    bg: '#3D50FF',
    fg: 'white'
  },
  {
    type: "block-tx-data",
    tabId:'Block & TX Data',
    bg: '#A3A3A3',
    fg: 'black'
  },
  {
    type: 'readonly-public-function',
    tabId:'Functions',
    bg: '#FF9090',
    fg: 'black'
  },
  {
    type: 'function',
    tabId:'Functions',
    bg: '#FF9090',
    fg: 'black'
  },
  {
    type: 'other',
    tabId:'Other',
    bg: '#B3FF8F',
    fg: 'black'
  },
]

export function getTypeByType(type) {
  console.log({type})
  return resourceTabList.find(x=>x.navigateOnClickOnType.includes(type))
  // return typesInTabs.find(x=>x.type==type) 
}